import { render, staticRenderFns } from "./MaioIcon.vue?vue&type=template&id=68a9b677&"
import script from "./MaioIcon.vue?vue&type=script&lang=js&"
export * from "./MaioIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports